import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import LicenseRenewalAbout from '@di-shared/features/public-service/license-renewal/LicenseRenewalAbout';

interface LicenseRenewalAboutPageProps {
  vin: string;
}

function LicenseRenewalAboutPage({vin}: LicenseRenewalAboutPageProps) {
  return (
    <>
      <ScrollToTopOnMount />
      <LicenseRenewalAbout vin={vin} />
    </>
  );
}

export default LicenseRenewalAboutPage;
